// Empty shim for modules not available on web
export default {
  hide: () => {},
  show: () => {},
} as any;

